module.exports = __webpack_public_path__ + "static/media/login-Image-new.47d2a73b.png";